export default "__VITE_ASSET__B5MAQW4e__"